/**
 * VAR
 * */

const headerProperty = document.querySelector('.single-property__header');
const recapProperty = document.querySelector('.single-property__recap');
const dpegeselements = document.querySelectorAll('.dpe, .ges');
const mapBox = document.getElementById('single-property__carte');
const openInfosPanel = document.querySelectorAll('.open-infos-panel');
const modalInfos = document.getElementById('modal');
const closeModal = document.querySelector('.modal__close');

/**
 * HOOK
 */
function updateVisible() {
  if (window.scrollY > headerProperty.getBoundingClientRect().bottom) {
    recapProperty?.setAttribute('data-visible', 'true');
  } else {
    recapProperty?.removeAttribute('data-visible');
  }
}

/**
 * MAIN
 */
window.addEventListener('scroll', updateVisible);
updateVisible();

openInfosPanel.forEach((item) => {
  item.addEventListener('click', () => {
    modalInfos.setAttribute('data-visible', 'true');
  });
});

closeModal.addEventListener('click', () => {
  modal.setAttribute('data-visible', '');
});

dpegeselements.forEach((element) => {
  element.addEventListener('click', () => {
    if (element.getAttribute('data-toggle') !== 'true') {
      element.setAttribute('data-toggle', 'true');
    } else {
      element.setAttribute('data-toggle', '');
    }
  });
});

/**
 * MAPBOX
 */
const latitude = parseFloat(mapBox.getAttribute('data-lat'));
const longitude = parseFloat(mapBox.getAttribute('data-lng'));

mapboxgl.accessToken =
  'pk.eyJ1IjoidGFuLWtpIiwiYSI6ImNsZDRidjBtejBxeTMzeG9nZ3JtcWs2dGsifQ.uKrP8MsXPQHZbhgBHfd0rw';

const map = new mapboxgl.Map({
  container: 'single-property__carte',
  style: 'mapbox://styles/tan-ki/clgm9u36o00c901mjazd99mj1',
  center: [longitude, latitude],
  zoom: 8,
  minZoom: 8,
  maxZoom: 12,
  attributionControl: false,
});

map.scrollZoom.disable();
map.addControl(new mapboxgl.NavigationControl());

map.on('load', () => {
  map.addLayer({
    id: 'circle-layer',
    type: 'circle',
    source: {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude],
            },
          },
        ],
      },
    },
    paint: {
      'circle-radius': 40,
      'circle-color': '#7699AE',
      'circle-opacity': 0.7,
    },
  });

  document.getElementById('single-property__carte').dataset.lat = '';
  document.getElementById('single-property__carte').dataset.lng = '';
});

/**
 * PLYR
 */

const players = document.querySelectorAll('.single-property__hkc__video');

players.forEach((player) => {
  const headerYT = new Plyr(player, {
    controls: ['play-large', 'play', 'progress', 'volume', 'fullscreen'],
    youtube: {
      noCookie: false,
      rel: 0,
      showinfo: 0,
      iv_load_policy: 3,
      modestbranding: 1,
    },
  });
});

/**
 * SWIPER
 * */

const carrouselTop = new Swiper('.single-property__carrousel', {
  slidesPerView: 1,
  pagination: {
    el: '.single-property__carrousel .swiper-pagination',
    clickable: true,
  },
  keyboard: {
    enabled: true,
  },
});

const hektorCarrousel = new Swiper('.single-property__hkc', {
  slidesPerView: 1,
  pagination: {
    el: '.single-property__hkc .swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.single-property__hkc .swiper-button-next',
    prevEl: '.single-property__hkc .swiper-button-prev',
  },
  loop: true,
  keyboard: {
    enabled: true,
  },
  autoHeight: true,
});

const othersProperties = new Swiper('#single-property-others', {
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.carrousel-biens .swiper-button-next',
    prevEl: '.carrousel-biens .swiper-button-prev',
  },
  freeMode: true,
  grabCursor: true,
  keyboard: {
    enabled: true,
  },
});
